



















import { RedactModule } from '@/store/modules/redact';
import { IMenu } from '@/types/menu';
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
@Component({})
export default class MoveToTemplateDialog extends Vue {
  @Prop()
  visible: boolean = false;

  @Prop({ type: Object, required: true })
  selectItem: IMenu | undefined;

  displaySelectItem: IMenu | {} = {};

  getPatternGroup(menuArr: IMenu[]) {
    const item = this.displaySelectItem as IMenu;
    const targetMenus = menuArr.filter(
      (i) => i.templatePattern === item.templatePattern && i.type === 'list',
    );
    const subs = menuArr.flatMap((i) =>
      i.subs.map((sub) => ({ ...sub, name: i.name + '-' + sub.name })),
    );
    if (subs.length) {
      return targetMenus.concat(this.getPatternGroup(subs));
    }
    return targetMenus;
  }

  get pages() {
    return RedactModule.pages;
  }

  get group() {
    return this.getPatternGroup(RedactModule.pages);
  }

  @Watch('selectItem')
  w(value: IMenu) {
    this.displaySelectItem = value;
  }

  onSelect(value: IMenu) {
    this.displaySelectItem = value;
  }
}
